import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { scaleLinear } from 'd3-scale';
import { LabeledDataPoint, PreparedDataPoint } from './data';
import { combinePrepared, SortType } from './helpers/combine-tail';

const MAX_LINES = 15;

@Component({
  selector: 'prepared-horizontal-bar',
  templateUrl: './horizontal-bar.component.html',
  styleUrls: ['./horizontal-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreparedHorizontalBarComponent<T> {
  @Input()
  data: PreparedDataPoint<T>[];

  @Input()
  getMetric: (metricData: T) => number;

  @Input()
  tailReducer: (items: T[]) => T;

  @Input()
  valueFormatter: (value: number) => string;

  @Input()
  sorted: SortType = 'DESC';

  getDataPoints(): LabeledDataPoint[] | null {
    if (!this.data) return null;
    return combinePrepared(
      this.data,
      MAX_LINES,
      this.getMetric,
      this.tailReducer,
      this.sorted,
    );
  }

  isEmpty(): boolean {
    const dataPoints = this.getDataPoints();
    return !dataPoints || !dataPoints.length;
  }

  getXScale() {
    const dataPoints = this.getDataPoints();
    const values = dataPoints ? dataPoints.map(p => p.value) : [0];
    return scaleLinear()
      .domain([0, Math.max(...values)])
      .range([0, 100]);
  }

  getXTicks() {
    return this.getXScale().ticks(5);
  }

  getTickContainerGridRow(): SafeStyle {
    const points = this.getDataPoints() || [];
    return this.sanitizer.bypassSecurityTrustStyle(`1 / ${points.length + 2}`);
  }

  constructor(private readonly sanitizer: DomSanitizer) {}
}
